import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PageActionType, PaginationModel} from './grid-pagination.model';

@Component({
	selector: 'cv-grid-pagination',
	templateUrl: './grid-pagination.component.html',
	styleUrls: ['./grid-pagination.component.scss']
})
export class GridPaginationComponent {

	FIRST_PAGE = 1;

	/**
	 * Emit value after any operation change over the limit/offset of the Pagination Model
	 */
	// eslint-disable-next-line @angular-eslint/no-output-on-prefix
	@Output() onPaginationChange: EventEmitter<any> = new EventEmitter<any>();

	@Input() pagination: PaginationModel;

	public pageActionType = PageActionType;

	/**
	 * Internal method not exposed that change the Page and emit the value
	 * @param pageActionType
	 */
	public goToPage(pageActionType: PageActionType): void {
		if (pageActionType === PageActionType.FIRST) {
			this.pagination.offset = 0;
		}

		if (pageActionType === PageActionType.PREVIOUS) {
			this.pagination.offset = this.pagination.offset - this.pagination.limit;
		}

		if (pageActionType === PageActionType.NEXT) {
			this.pagination.offset = this.pagination.offset + this.pagination.limit;
		}

		if (pageActionType === PageActionType.LAST) {
			this.pagination.offset = (this.getTotalPages() - 1) * this.pagination.limit;
		}

		// emit
		this.onPaginationChange.emit(this.pagination);
	}

	/**
	 * The the first page number to display.
	 */
	getFirstPageNumber(): number {
		if (!this.pagination.totalCount) {
			return 0;
		}
		return this.pagination.offset + 1;
	}

	/**
	 * Get the Current Page Number
	 */
	public getCurrentPage(): number {
		return Math.ceil(this.pagination.offset / this.pagination.limit) + 1;
	}

	/**
	 * Get current limit of current set of items being displayed.
	 */
	getCurrentLimit(): number {
		const currentOffset = this.pagination.offset + this.pagination.limit;
		return currentOffset > this.pagination.totalCount ? this.pagination.totalCount : currentOffset;
	}

	/**
	 * Get the Total of Pages for the current Model
	 */
	public getTotalPages(): number {
		if (!this.pagination.totalCount) {
			return 1;
		}
		return Math.ceil(this.pagination.totalCount / this.pagination.limit);
	}

	public onKeydown(event): void {
		if (event.keyCode === 32 || event.keyCode === 13) {
			event.preventDefault()
		  }	
	}
}
